import { RadioButtonGroup, RadioButtonGroupField } from "browser/components/atomic-elements/atoms/radio-button/radio-button-group-field";
import { WithDefaultProps } from 'browser/components/atomic-elements/higher-order-components/with-default-props'
import { JSONSelectFactory } from "browser/components/json-elements/higher-order-components/json-select-factory";

import { IRadioButtonGroupProps } from 'browser/components/atomic-elements/atoms/radio-button/radio-button-group'

export const UIRadioButtonGroup = JSONSelectFactory(RadioButtonGroup)
export const UIRadioButtonGroupField = JSONSelectFactory(RadioButtonGroupField)

export const MobileRadioButtonGroup = WithDefaultProps<IRadioButtonGroupProps>(UIRadioButtonGroup, {
  containerClassName: 'mobile-control',
})

export const MobileRadioButtonGroupField = WithDefaultProps<IRadioButtonGroupProps>(UIRadioButtonGroupField, {
  containerClassName: 'mobile-control',
})
